import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Parametro, ParametroUpdateRequest } from '../models/parametro.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParametrosService {
  constructor(private _http: HttpClient) {}

  obtenerParametros(): Observable<Parametro[]> {
    return this._http.get<Parametro[]>(`${environment.urlApi}/Parameters`);
  }

  actualizarParametro(
    key: string,
    data: ParametroUpdateRequest
  ): Observable<void> {
    return this._http.put<void>(
      `${environment.urlApi}/Parameters/${key}`,
      data
    );
  }
}
